// extracted by mini-css-extract-plugin
export default {"heroContent":"di4LKFG1KugaUJd8Xygn","sublead":"zwQBFdQcHqsjZPdf4HCE"};